<template>
    <div>
        <div v-if="this.isLoading" class="deals-wrapper">
            <LoadMoreDeals v-if="!isGiftList" />            
        </div>
        <div v-if="isClean && listOfDeals">
            <input placeholder="Search..." v-model="filterText" @input="onFilterChange()" />
        </div>
        <div id="deals-wrapper" v-if="!isGiftList && this.deals && this.deals.length > 0">
            
            <div v-for="(deal, index) in this.deals" v-bind:item="deal" v-bind:index="index" v-bind:key="deal.DealID" class="deals-wrapper-item">
                <div v-if="deal.DealID > 1000000000" ref="adlist">

                    <div v-if="deal.adType === 'GOOGLE'" class="ad-container">
                        <ins class="adsbygoogle"
                             style="display:block"
                             data-ad-format="fluid"
                             data-ad-layout-key="-8b-22+5x-8o-ai"
                             data-ad-client="ca-pub-7343448629459478"
                             data-ad-slot="8520665225">
                        </ins>
                    </div>
                    <div v-else-if="deal.adType === 'MEDIA.NET'">
                        <div id="471381230"></div>
                    </div>
                    <div v-else-if="deal.adType === 'JCN'">
                        <div class="jcn-ad-container" v-html="deal.adContent">
                        </div>
                    </div>
                    <div v-else class="join-us-deal-container">
                        <a :href="settings.socialLinks.whatsapp" target="_blank">
                            <img :src="'/Assets/' + settings.siteName + '/img/deal-join-whatsapp.jpg'" />
                        </a>
                    </div>
                </div>
                <DealBox v-else :deal="deal" :index="index" class="deals-wrapper-dealbox" />
            </div>
        </div>
        <div id="gift-list-wrapper" v-if="isGiftList && this.deals && this.deals.length > 0">
            <div v-for="(deal, index) in this.deals"
                 v-bind:item="deal"
                 v-bind:index="index"
                 v-bind:key="deal.DealID"
                 class="gift-list-wrapper-item">
                <DealBox :deal="deal" :index="index" class="deals-wrapper-dealbox" :directLinks="directLinks" />
            </div>
        </div>
        <div class="load-more-container" v-if="this.showMoreDealsButton">
            <button v-if="this.isLoadingMore === true">
                <span class="icon"><img src="/Assets/img/spin.svg" /></span>
            </button>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import LoadMoreDeals from '@/components/LoadMoreDeals.vue'
    import DealBox from '@/components/DealBox.vue'
    import api from '@/api'
    import settings from '@/settings'
    import ga from '@/helpers/ga'
    import clicky from '@/helpers/clicky'
    import util from '@/helpers/util'

    export default {
        name: 'home',
        components: {
            DealBox,
            LoadMoreDeals
        },
        props: ['excludeDeal', 'listOfDeals', 'date', 'showJoinUs'],
        data() {
            return {
                isLoading: false,
                isLoadingMore: false,
                deals: null,
                dealsPerPage: settings.siteName === 'mommydeals' ? 15 : 16,
                pageNumber: 1,
                showMoreDealsButton: false,
                autoLoadMoreEnabled: false,
                oneSignalInitiated: false,
                isGiftList: false,
                isClean: false,
                filterText: null,
                filterCounter: 0
            }
        },
        mounted() {
            this.init();
        },
        created() {
            window.addEventListener('scroll', this.autoLoadMore);
        },
        destroyed() {
            window.removeEventListener('scroll', this.autoLoadMore);
        },
        computed: {
            finalExcludeDeal: function () {
                return (this.excludeDeal ? this.excludeDeal : 0);
            },
            settings: function () {
                return settings;
            }
        },
        methods: {
            onFilterChange() {
                this.filterCounter++;
                let filterCounter = this.filterCounter;
                setTimeout(() => {
                    if (filterCounter === this.filterCounter) {
                        this.deals = this.listOfDeals.filter(d => d.Title.toLowerCase().includes(this.filterText.toLowerCase()))
                    }
                }, 500)
            },
            init() {

                if (this.$route.query.direct)
                    this.isClean = true;
                else
                    this.isClean = false;

                if (this.$route.name == 'giftideas' || this.$route.name == 'giftlist' || this.$route.name == 'giftlist2') {
                    this.isGiftList = true;
                }


                if (this.listOfDeals) {
                    this.dealsPerPage = 300;
                    this.pageNumber = 1;
                    this.deals = this.listOfDeals;
                }
                else {

                    if (this.date) {
                        this.dealsPerPage = 49;
                    }

                    this.isLoading = true;
                    this.isLoadingMore = false;
                    this.deals = [];
                    this.loadData().then(() => {
                        this.isLoading = false;
                        this.showMoreDealsButton = true;
                    });
                }

                

            },
            autoLoadMore() {
                if (this.autoLoadMoreEnabled) {
                    var loadMoreElem = document.querySelector('.load-more-container');
                    if (loadMoreElem && util.checkVisible(loadMoreElem)) {
                        this.loadMoreData();
                    }
                }
            },
            loadMoreData() {

                this.autoLoadMoreEnabled = false;

                ga.event('click', { 'event_category': 'dealpage', 'event_label': this.pageNumber });
                clicky.log('Load More Deals - Page #' + this.pageNumber, 'click');

                //MEDIA.NET CHANGE ID
                if (document.getElementById('471381230'))
                    document.getElementById('471381230').id = 'AD_DONE';


                this.isLoadingMore = true;
                this.loadData().then(() => {
                    this.isLoadingMore = false;
                    this.loadOneSignal();
                });
            },
            loadData() {
                if (this.date) {
                    return api.getDealsByDate(this.dealsPerPage, this.pageNumber, this.finalExcludeDeal, this.date).then(this.postLoadData);
                }
                else {
                    return api.getLatestDeals(this.dealsPerPage, this.pageNumber, this.finalExcludeDeal).then(this.postLoadData);
                }
            },
            postLoadData(response) {
                if (response.data) {

                    let newDeals = response.data;
                    let adDeal = { DealID: 1000000000 + this.pageNumber };

                    if (newDeals.length < this.dealsPerPage) this.showMoreDealsButton = false;

                    if (settings.siteName === 'mommydeals' || settings.siteName === '5tcdeals')
                        newDeals.splice(3, 0, adDeal);


                    this.deals.push(...newDeals);
                    this.pageNumber = this.pageNumber + 1;

                    setTimeout(() => {
                        this.autoLoadMoreEnabled = true;
                    }, 500);

                    //if (!this.showJoinUs)
                    //{
                    if (settings.siteName === 'mommydeals') {

                        //TRY JCN AD
                        let randomNumber = Math.floor(Math.random() * 6);
                        let zid = 108;
                        let pid = settings.jcn_pid;
                        let jcn_ads_on = settings.jcn_ads_on;
                        let medianet_on = settings.medianet_on && randomNumber == 0;
                        let isJCNAd = true;

                        if (medianet_on) {
                            try {
                                Vue.set(adDeal, 'adType', 'MEDIA.NET');
                                setTimeout(() => {
                                    window._mNHandle.queue.push(function () {
                                        window._mNDetails.loadTag("471381230", "300x250", "471381230");
                                    });
                                }, 100);
                            }
                            catch (error)
                            {
                                console.log('Media.net ERROR', error)
                            }
                        }
                        else if (jcn_ads_on) {
                            api.getJCNAd(zid, pid).then((response) => {
                                console.log('JCN response', response)
                                isJCNAd = response && response.data && response.data.includes('<body');

                                if (isJCNAd) {
                                    Vue.set(adDeal, 'adContent', response.data);
                                    Vue.set(adDeal, 'adType', 'JCN');
                                }
                                else {
                                    Vue.set(adDeal, 'adType', 'GOOGLE');
                                    this.loadGoogleAds();
                                }

                                console.log('AD TYPE', adDeal.adType);

                            });
                        }
                        else
                        {
                            Vue.set(adDeal, 'adType', 'GOOGLE');
                            this.loadGoogleAds();
                            console.log('AD TYPE', adDeal.adType);
                        }


                    }

                }
            },
            loadGoogleAds() {
                setTimeout(() => {
                    (window.adsbygoogle = window.adsbygoogle || []).push({});
                }, 100);
            },
            loadOneSignal() {

                //var OneSignal = window.OneSignal || [];
                //
                //window.console.log('OneSignal', OneSignal);



            },
            promptOneSignal() {

                //if (!this.oneSignalInitiated) {
                //
                //    console.log('initiating oneSignal');
                //
                //    this.oneSignalInitiated = true;
                //
                //    var OneSignal = window.OneSignal || [];
                //    OneSignal.push(function () {
                //        OneSignal.init({
                //            appId: "a4e63c71-0d91-4957-a433-3017a56ced31",
                //            promptOptions: {
                //                slidedown: {
                //                    enabled: true,
                //                    autoPrompt: false,
                //                    timeDelay: 3
                //                }
                //            }
                //        });
                //    });
                //}
                //
                //window.OneSignal.showNativePrompt();
            }


        }

    }
</script>
